import React, { Component } from 'react';
import { connect } from 'react-redux';
import './sms.css';
import CustomLoading from '../../../util_components/custom_loading';
import ToggleSwitch from '../../../util_components/ToggleSwitch';
import { post_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import * as actions from '../../../../redux/action_creators';
import { SMSHandler } from '../../../../myt_chat/worker/chatProxies';
import moment from 'moment';
import { ChatClient } from '../../../../myt_chat/worker/chatProxies';
import ConnectionState from '../../../../myt_chat/chat/enums/ConnectionState';
import { CallbackHandler } from '../../../../myt_chat/chat/callbacks/handler';
import { SMSChannelPkt } from '../../../../myt_chat/chat/packets/SMSChannel';
import UserRole from '../../../../myt_chat/chat/enums/UserRole';
import { WhatsappIcon, SMSIcon, DOCIcon } from '../../../../utils/svg';
import PredefinedMessage from '../../../../components/views/reports/modal/PredefinedMessageModal';
import SharedMediaRenderer from './SharedMediaRenderer';
import { isMobileViewport } from '../../../../utils/responsive/viewport';
import { attachKeyboardInset } from '../../../../utils/responsive/keyboardInset';
class SmsWindow extends Component {
  messageEnd = React.createRef();

  // Root element of the full-screen panel; used to apply the mobile keyboard inset.
  windowRef = React.createRef<HTMLDivElement>();

  kbdCleanup?: () => void;

  constructor(props) {
    super(props);

    this.state = {
      is_loading: false,
      add_student_uuid: '',
      sms_data_of_user: [],
      new_sms: '',
      student_name: '',
      sending_sms: false,
      timeLeft: '24:00:00',
      showTimer: false,
      messageDispatcher: '',
      replied_time: '',
      is_whatsapp: this.props.message_dispatch_method === 'whatsapp',
      predefined_msg: false,
      openImage: false,
      selected_template: null
    };
  }
  timerInterval: number | null = null;

  smsHandler = (item: SMSChannelPkt) => {
    console.log('smswindow->smshandler->', JSON.stringify(item));
    if (!item.channel.endsWith(this.state.add_student_uuid)) {
      return;
    }

    const smsItem = {
      uuid: item.id,
      to_student: item.to.role === UserRole.STUDENT ? 1 : 0,
      sms_timestamp: moment.utc(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
      sms_body: item.text,
      sender_name: item.from.name,
      message_type: item.from.messageSentBy || 'sms',
      status: item.status,
      sms_epoch_time: item.timestamp,
      media: item.media
    };

    const indexedElement = this.state.sms_data_of_user.find((x) => {
      return x.uuid === smsItem.uuid;
    });

    if (indexedElement !== undefined) {
      return;
    }

    const newItems = [...this.state.sms_data_of_user];

    newItems.push(smsItem);

    this.setState(
      {
        sms_data_of_user: newItems
      },
      () => {
        this.scrollToBottom();
      }
    );
  };
  componentDidMount() {
    this.setState(
      {
        add_student_uuid: this.props.student_uuid,
        student_name: this.props.student_name,
        original_message_uuid: this.props.original_message_uuid
      },
      () => {
        this.load_data();
      }
    );

    CallbackHandler.shared.registerSMSHandler(this.smsHandler);

    // Keep the composer above the on-screen keyboard on mobile (full-screen mode).
    if (isMobileViewport()) {
      this.kbdCleanup = attachKeyboardInset(() => this.windowRef.current);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.student_uuid === this.props.student_uuid) {
      return;
    }

    this.setState(
      {
        add_student_uuid: this.props.student_uuid,
        student_name: this.props.student_name,
        original_message_uuid: this.props.original_message_uuid
      },
      () => {
        this.load_data();
      }
    );
  }

  componentWillUnmount() {
    CallbackHandler.shared.unregisterSMSHandler(this.smsHandler);
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.kbdCleanup?.();
  }
  isAnyMessageSentByStudent = () => {
    const messages = this.state.sms_data_of_user || [];
    if (messages.length === 0) return false; // No messages available

    return (
      this.props.message_dispatch_method === 'whatsapp' &&
      messages.some((mess: any) => mess.to_student === 0 && mess.message_type === 'whatsapp')
    );
  };
  render_timer = () => {
    const messages = this.state.sms_data_of_user;

    const lastMessageToStudent = [...messages]
      .reverse()
      .find((msg) => msg.to_student === 0 && msg.message_type === 'whatsapp');

    let shouldShowTimer = false;

    if (lastMessageToStudent) {
      const createdTime = lastMessageToStudent.sms_epoch_time;
      const expirationTime = createdTime + 24 * 60 * 60 * 1000;
      const currentTime = Date.now();

      shouldShowTimer =
        this.props.message_dispatch_method === 'whatsapp' &&
        currentTime < expirationTime &&
        this.isAnyMessageSentByStudent();
    }

    if (!shouldShowTimer) {
      return null;
    }

    if (!this.state.is_whatsapp) {
      return null;
    }

    return (
      <div>
        <div className="border-t border-b border-[var(--state-error-bg)] bg-[var(--state-error-bg)] px-[15px] py-[14px]">
          <div className="text-[var(--state-error)] text-center font-inter text-[13px] font-medium leading-[14px]">
            Time left to reply {this.state.timeLeft}
          </div>
        </div>
      </div>
    );
  };

  load_data = () => {
    if (!!!this.state.add_student_uuid) {
      return;
    }

    const connectionListener = (state: ConnectionState) => {
      if (state !== ConnectionState.AUTHENTICATED) {
        CallbackHandler.shared.registerConnectionListener(connectionListener);
        return;
      }

      CallbackHandler.shared.unregisterConnectionListener(connectionListener);

      this.setState({
        is_loading: true
      });

      SMSHandler.shared.fetchSMSArchive(this.state.add_student_uuid).then((result) => {
        let items = result.messages.map((item) => {
          return {
            uuid: item.id,
            to_student: item.toStudent ? 1 : 0,
            sms_timestamp: moment.utc(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
            sms_body: item.text,
            sender_name: item.profile.name,
            message_type: item.messageSentBy,
            status: item.status,
            sms_epoch_time: item.timestamp,
            media: item.media
          };
        });

        this.setState(
          {
            sms_data_of_user: items,
            is_loading: false
          },
          () => {
            this.startTimer();
            this.scrollToBottom();
          }
        );
      });
    };

    connectionListener(ChatClient.shared.connectionState());
  };

  send_success_notification = () => {
    try {
      this.props.send_success_notification?.();
    } catch (e) {
      console.log('smswindow->send_success_notification->', e);
    }
  };

  openPredefinedMessage = () => {
    this.setState((prev) => ({
      predefined_msg: !prev.predefined_msg
    }));
  };

  closePredefinedModal = () => {
    this.setState({ predefined_msg: false, selected_template: null });
  };

  reply_user = (message_method = 'sms', message_tag = '') => {
    if (this.state.new_sms.trim() === '' && message_tag === '') {
      return;
    }
    this.setState({ sending_sms: true }, () => {
      let api_url = '/v2/notifications/twilio/send_message';
      const url = get_api_url(api_url, false, true);
      let payload;
      payload = {
        to_student_uuid: this.state.add_student_uuid,
        message: this.state.new_sms,
        sms_template_tag: message_tag,
        message_medium_type: message_method === 'whatsapp' ? 'WHATSAPP' : 'SMS',
        original_message_uuid:
          this.props.original_message_uuid != undefined ? this.props.original_message_uuid : ''
      };

      post_api(url, payload, true)
        .then((response) => {
          if (response?.data?.status === 'failure') {
            let err_message;
            try {
              if (response?.data?.code === 424) {
                err_message = 'Message too long. please reduce the size';
              } else {
                err_message = response?.data?.reason;
              }
            } catch (err) {
              err_message = 'Some error occured. Please contact dev team.';
            }
            this.props.set_notification_variable(true, 'error', err_message);
            this.setState({ is_loading: false, sending_sms: false, selected_template: null });
          } else {
            this.setState({
              new_sms: '',
              sending_sms: false,
              predefined_msg: false,
              selected_template: null
            });
            this.send_success_notification();
            this.load_data();
          }
        })
        .catch((e) => {
          console.log('smswindow->reply_user->', e);
          let err_message;
          try {
            err_message = e.response?.data?.reason || e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ is_loading: false, sending_sms: false, selected_template: null });
        });
    });
  };

  onCommonChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    this.setState({ [key]: value });
  };

  scrollToBottom = () => {
    try {
      setTimeout(() => {
        if (this.messageEnd.current) {
          const height = this.messageEnd.current.scrollHeight;
          this.messageEnd.current.scrollTo({
            top: height
          });
        }
      }, 100);
    } catch (e) {
      console.log('smswindow->scrollToBottom->', e);
    }
  };

  render_sms = () => {
    const singleTick = 'https://images.myyogateacher.com/icons/single-sent-tick.svg';
    const doubleTick = 'https://images.myyogateacher.com/icons/grey-read-tick.svg';
    const blueTick = 'https://images.myyogateacher.com/web_images/double_tick.svg';

    const statusImages = [singleTick, doubleTick, blueTick];
    const { iana_timezone } = this.props;

    const groupedMessages = this.state.sms_data_of_user.reduce((groups, message) => {
      const date = moment(message.sms_timestamp).format('YYYY-MM-DD');
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(message);
      return groups;
    }, {});

    const sortedDates = Object.keys(groupedMessages).sort((a, b) => moment(a).diff(moment(b)));

    const getDateHeader = (date) => {
      const today = moment().tz(this.props.iana_timezone).format('YYYY-MM-DD');
      const yesterday = moment()
        .tz(this.props.iana_timezone)
        .subtract(1, 'days')
        .format('YYYY-MM-DD');

      if (date === today) {
        return 'Today';
      } else if (date === yesterday) {
        return 'Yesterday';
      } else {
        return moment(date).tz(this.props.iana_timezone).format('DD MMM YYYY');
      }
    };

    return (
      <div className="c-c-messages" ref={this.messageEnd}>
        {sortedDates.map((date) => (
          <React.Fragment key={date}>
            <div className="text-center my-4">
              <div className="text-[var(--text-muted)] text-xs rounded-full flex items-center gap-2.5 leading-[15px] font-medium justify-center">
                <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex "></span>
                {getDateHeader(date)}
                <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex"></span>
              </div>
            </div>
            {groupedMessages[date].map((sms) => {
              let timeDisplay = '--:--';
              if (sms?.sms_timestamp && iana_timezone && moment(sms.sms_timestamp).isValid()) {
                timeDisplay = moment(sms.sms_timestamp).tz(iana_timezone).format('HH:mm');
              }

              return (
                <div className={sms.to_student == 1 ? 'my-sms' : 'friend-sms'} key={sms.uuid}>
                  <div
                    className="chat-cmt-box"
                    style={{
                      background:
                        sms.to_student == 1 ? 'var(--state-info-bg)' : 'var(--surface-sunken)',
                      color: 'var(--text-primary)'
                    }}
                  >
                    {Array.isArray(sms.media) &&
                    sms.media.length > 0 &&
                    Object.keys(sms.media[0]).length > 0 ? (
                      <SharedMediaRenderer sms={sms} />
                    ) : (
                      ''
                    )}
                    <br />
                    <span>{sms.sms_body}</span>
                    <div className={sms.to_student == 1 ? 'sms-time chat-me' : 'sms-time'}>
                      <div>{timeDisplay}</div>
                      <div className="flex gap-2">
                        <div>
                          {sms.message_type === 'whatsapp' ? <WhatsappIcon /> : <SMSIcon />}
                        </div>
                        <div>{sms.sender_name}</div>
                      </div>
                      <div>
                        {sms.to_student === 1 && sms.status >= 0 && sms.status <= 2 && (
                          <img
                            src={statusImages[sms.status]}
                            alt={`Status ${sms.status}`}
                            width="20"
                            height="20"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end"></div>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    );
  };

  toggle_message_type = () => {
    this.setState({ is_whatsapp: !this.state.is_whatsapp, predefined_msg: false });
  };

  render_header = () => {
    const { is_whatsapp, student_name } = this.state;
    const { message_dispatch_method, close_fn, is_allowed_whatsapp, is_allowed_sms } = this.props;
    return (
      <div className="c-c-header">
        <div className="c-c-header-c">
          <div className="flex items-center justify-between w-full">
            <span>{student_name}</span>
            {message_dispatch_method !== 'none' && is_allowed_whatsapp && is_allowed_sms ? (
              <div>
                <ToggleSwitch enabled={is_whatsapp} setEnabled={this.toggle_message_type} />{' '}
                {is_whatsapp ? 'WA' : 'SMS '}
              </div>
            ) : null}
            <div></div>
          </div>
        </div>
        <div className="c-c-header-i">
          <button className="chat-c-btn last-btn" onClick={close_fn}>
            <img
              className="close_min_chat"
              src="https://images.myyogateacher.com/ic_cross_ch1.svg"
              alt="c"
            />
          </button>
        </div>
      </div>
    );
  };

  render_predefined_message_btn = () => {
    const { selected_template } = this.state;
    return (
      <div
        className="btn btn-primary cursor-pointer w-full text-13.5px h-38px"
        onClick={() => {
          selected_template !== null
            ? this.reply_user('whatsapp', selected_template)
            : this.openPredefinedMessage();
        }}
      >
        {selected_template !== null ? 'Send predefined message' : 'Select predefined message'}
      </div>
    );
  };

  checkForWhatsapPredefinedMessage = () => {
    const { is_whatsapp } = this.state;
    if (!this.isAnyMessageSentByStudent() && is_whatsapp) {
      return true;
    }
  };

  render_footer = () => {
    if (this.checkForWhatsapPredefinedMessage()) {
      return <div className="c-c-i-c">{this.render_predefined_message_btn()}</div>;
    }

    const { is_whatsapp, timeLeft, new_sms } = this.state;
    const { is_allowed_whatsapp, is_allowed_sms, message_dispatch_method } = this.props;

    return (
      <div className="c-c-i-c">
        {message_dispatch_method !== 'whatsapp' ||
        !is_whatsapp ||
        (timeLeft !== '00:00:00' && this.isAnyMessageSentByStudent()) ? (
          <div className="textarea-cont">
            <textarea
              className="textarea"
              value={new_sms}
              name="new_sms"
              onChange={this.onCommonChange}
            />
            <button
              type="button"
              className={`send-btn-c ch_send_btn ${
                message_dispatch_method !== 'none' && is_whatsapp ? 'whatsapp_bg' : 'sms_bg'
              }`}
              onClick={() =>
                this.reply_user(
                  message_dispatch_method === 'whatsapp' && is_whatsapp ? 'whatsapp' : 'sms'
                )
              }
            >
              {message_dispatch_method !== 'none' && is_whatsapp ? 'Send WA' : 'Send SMS'}
            </button>
          </div>
        ) : (
          this.render_predefined_message_btn()
        )}
      </div>
    );
  };

  startTimer = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    const message = this.state.sms_data_of_user;

    const lastMessageToStudent = [...message].reverse().find((msg) => msg.to_student === 0);

    let createdTime = Date.now();
    if (lastMessageToStudent) {
      createdTime = lastMessageToStudent.sms_epoch_time;
    }

    const expirationTime = createdTime + 24 * 60 * 60 * 1000;

    const updateTimer = () => {
      const currentTime = Date.now();
      const remainingTime = expirationTime - currentTime;

      if (remainingTime <= 0) {
        this.setState({
          timeLeft: '00:00:00',
          is_loading: false
        });
        clearInterval(this.timerInterval);
        return;
      }

      const hours = Math.floor(remainingTime / (1000 * 60 * 60));
      const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      this.setState({
        timeLeft: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
        is_loading: false
      });
    };

    updateTimer();
    this.timerInterval = setInterval(updateTimer, 1000);
  };

  handleSelectMessage = (message: string) => {
    this.setState({ selected_template: message });
  };

  render() {
    return this.state.is_loading ? (
      <CustomLoading />
    ) : (
      <div className="sms-window ch_new" ref={this.windowRef}>
        {this.render_header(this.state.student_name)}
        <div className="c-c-content">
          {this.render_timer()}
          {this.render_sms()}
          {this.render_footer()}
          {this.state.predefined_msg ? (
            <PredefinedMessage
              onSelect={this.handleSelectMessage}
              onSend={(tag) => this.reply_user('whatsapp', tag)}
              studentUUID={this.props.student_uuid}
              onClose={this.closePredefinedModal}
            />
          ) : null}
        </div>
        {this.state.sending_sms ? <CustomLoading full_loader={true} /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    iana_timezone: state.home.iana_timezone
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_notification_variable: (show, type, mes) => {
      dispatch(actions.set_notification_variable(show, type, mes));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SmsWindow);
